import styled from 'styled-components';

import type { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Drawer } from '@sorare/core/src/atoms/layout/Drawer';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import type {
  ClickAddToCart_Origin,
  ClickInstantBuy_Flow,
} from '@sorare/core/src/protos/events/so5/shared/events';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';
import { regularMaterial } from '@sorare/core/src/style/utils';

import type { Variant } from './Content';
import { Content } from './Content';

export { Variant as PlayerMarketDrawerVariant } from './Content';

const StyledDrawer = styled(Drawer)`
  width: 100%;
  height: 100%;
  ${regularMaterial}
  @media ${tabletAndAbove} {
    width: 480px;
  }
`;

type Props = {
  onClose: () => void;
  canUseConversionCredit?: boolean;
  playerSlug: string | null;
  sport: Sport;
  variant: Variant;
  collection?: {
    playerName?: string | null;
    rarity?: Rarity | null;
    teamSlug?: string | null;
    teamName?: string | null;
    seasonName?: string;
    seasonStartYear?: number;
    link?: string;
  };
  origin?: {
    instantBuy: ClickInstantBuy_Flow;
    addToCart: ClickAddToCart_Origin;
  };
};

export const PlayerMarketDrawer = ({
  playerSlug,
  sport,
  collection,
  canUseConversionCredit,
  onClose,
  origin,
  variant,
}: Props) => {
  const { up: isTabletOrAbove } = useScreenSize('tablet');
  return (
    <StyledDrawer
      open={!!playerSlug}
      side={isTabletOrAbove ? 'right' : 'bottom'}
      onBackdropClick={onClose}
    >
      <Content
        playerSlug={playerSlug}
        collection={collection}
        canUseConversionCredit={canUseConversionCredit}
        onClose={onClose}
        origin={origin}
        sport={sport}
        variant={variant}
      />
    </StyledDrawer>
  );
};
